/**
 * What happened when a proposed carryover address was checked. Distinguishes an address which failed the
 * mileage check from one which could not be checked at all.
 */
export enum CarryoverAddressValidationOutcome {
  /** The address was checked and the carryover mileage is acceptable. */
  Suitable = 0,

  /** The address was checked and the carryover adds too much mileage. */
  MileageUnsuitable = 1,

  /** The address could not be located, so no check was made. The address needs correcting. */
  AddressNotFound = 2,

  /** The check could not be completed, so nothing is known about the mileage. */
  CheckUnavailable = 3,
}
